import { Store } from "artisn/types";
import { GetStaticProps } from "next";
import Head from "next/head";
import React from "react";
import { QueryClient } from "react-query";
import { dehydrate } from "react-query/hydration";

import Categories from "components/categories/Categories/Categories";
import TabsMenu from "components/global/TabsMenu/TabsMenu";
import CONSTANTS from "config/constants";
import { prefetchCategoriesWithProducts } from "utils/cache.utils";
import { prefetchDefaultStore } from "utils/cache.utils";
import { notify } from "utils/common.utils";

const { CATEGORIES_PER_REQUEST, PRODUCTS_PER_CATEGORY_REQUEST } = CONSTANTS.API;

interface Props {}

const CategoriesPage = (props: Props) => {
  return (
    <>
      <Head>
        <title>
          Chef Choy | revisa el menú de la mejor comida china a domicilio en
          Quito
        </title>
        <meta
          property="og:title"
          content="Chef Choy | revisa el menú de la mejor comida china a domicilio en
          Quito"
        />
        <meta
          key="categories"
          name="description"
          content="Explora nuestro menú y ordena tu comida china a domicilio en Quito con Chef Choy ¡Haz tu pedido ya!"
        />
        <meta
          property="og:description"
          content="Explora nuestro menú y ordena tu comida china a domicilio en Quito con Chef Choy ¡Haz tu pedido ya!"
        />
        <meta name="keywords" content="Menú Chef Choy" />
        <meta name="robots" content="index, follow" />
      </Head>
      <h1>Menú Chef Choy - ordena tu comida china en Quito</h1>
      <TabsMenu>
        <Categories />
      </TabsMenu>
    </>
  );
};

export const getStaticProps: GetStaticProps = async context => {
  const queryClient = new QueryClient();

  try {
    // Default store
    await prefetchDefaultStore(queryClient);
    const defaultStore = queryClient.getQueryData<Store>(["stores", "default"]);

    // Products
    const categoriesWithProducts = prefetchCategoriesWithProducts(queryClient, {
      storeId: defaultStore!.storeId,
      productsByGroup: PRODUCTS_PER_CATEGORY_REQUEST,
      size: CATEGORIES_PER_REQUEST
    });

    await Promise.all([categoriesWithProducts]);
  } catch (e) {
    notify(e, "Prefetch default store and categories with products");
    console.error(e.message);
  }

  return {
    props: {
      dehydratedState: JSON.parse(JSON.stringify(dehydrate(queryClient)))
    },
    revalidate: 60 * 30
  };
};

export default CategoriesPage;
